<template>
  <v-list-tile
    @click.prevent="addProvider"
    v-if="list"
  >
    <v-list-tile-action v-if="icon">
      <v-icon color="primary">{{ icon }}</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      <v-list-tile-title><slot>{{ provider.name }}</slot></v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
  <a href="#"
    @click.prevent="addProvider"
    class="add-provider-link"
    :class="linkKlass"
    v-else
  ><slot>{{ provider.name }}</slot></a>
</template>

<script>
  export default {
    computed: {
      folder () {
        return {
          provider_id: this.provider.id,
          service_types: this.serviceTypes,
          provider: this.provider
        }
      },
      linkKlass () {
        return {
          'add-provider-link--undecorated': !this.decoration
        }
      }
    },
    props: {
      provider: {
        type: Object,
        required: true
      },
      serviceTypes: {
        type: Array,
        default: function () { return [] }
      },
      decoration: {
        type: Boolean,
        default: true
      },
      list: {
        type: Boolean,
        default: false
      },
      icon: {
        type: [String, Boolean],
        default: false
      },
      track: {
        type: [Object, Boolean],
        default: function () { return false }
      }
    },
    methods: {
      addProvider () {
        this.$store.dispatch('user/authenticate', {
          action: 'folders/createFolder',
          payload: this.folder
        })
      }
    }
  }
</script>

<style lang="stylus">
  .add-provider-link
    &--undecorated
      text-decoration: none
      &:hover, &:focus
        text-decoration: underline
</style>



// WEBPACK FOOTER //
// frontend/src/components/common/AddProviderLink.vue